import { setSession, getSession } from './session'
import { TOKEN } from '../constants'
export * from './request'
export * from './session'
export * from './tools'

// provide for electron
window.__setToken = function (token) {
  setSession(TOKEN, token)
}

setInterval(() => {
  if (window.__setTokenForElectron) {
    const token = getSession(TOKEN)
    if (token) window.__setTokenForElectron(token)
  }
}, 1000)
